import { render, staticRenderFns } from "./EmbedSimple.vue?vue&type=template&id=ca6f22d6&"
import script from "./EmbedSimple.vue?vue&type=script&lang=js&"
export * from "./EmbedSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports